module.exports = __webpack_public_path__ + "img/banner-features.19d8d020.jpg";